<template>
  <v-card tile>
    <v-card-text>
      <div v-if="isAuthenticated" :id="planId" :ref="planId"></div>
      <div v-else>Please login to purchase this product.</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

const ID_KEY = process.env.VUE_APP_PAYPAL_ACCOUNT_CLIENT_ID;
export default {
  name: "PayPal",
  components: {},
  props: {
    planId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      cardPaymentMethod: null,
      paymentsClient: null
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "errors"])
  },
  watch: {
    paymentsClient() {
      this.injectButton();
    }
  },

  created() {
    this.injectPayPalScript();
    // this.injectButton();
  },

  methods: {
    injectPayPalScript() {
      if (!this.paymentsClient) {
        const PayPalScript = document.createElement("script");
        PayPalScript.setAttribute(
          "src",
          `https://www.paypal.com/sdk/js?client-id=${ID_KEY}&vault=true`
        );
        PayPalScript.setAttribute("name-space", "paypal");
        // eslint-disable-next-line
        PayPalScript.onload = () => (this.paymentsClient = paypal);
        document.head.appendChild(PayPalScript);
      }
    },
    injectButton() {
      let vm = this;
      if (this.paymentsClient && this.planId) {
        let payload = {
          plan_id: this.planId
        };
        this.paymentsClient
          .Buttons({
            createSubscription: function(data, actions) {
              return actions.subscription.create(payload);
            },
            onApprove: function(data) {
              vm.$emit("approve", data);
              // TODO: Save to set permission
            },
            onCancel: function(data) {
              vm.$emit("cancel", data);
            },
            onError: function(err) {
              vm.$emit("error", err);
            },
            style: {
              color: "white",
              branding: "false",
              label: "subscribe",
              shape: "rect"
            }
          })

          .render(this.$refs[this.planId]);
      }
    }
  }
};
</script>

<style>
</style>